import { render, staticRenderFns } from "./ser_suggestion.vue?vue&type=template&id=46ab40a8&scoped=true&"
import script from "./ser_suggestion.vue?vue&type=script&lang=js&"
export * from "./ser_suggestion.vue?vue&type=script&lang=js&"
import style0 from "./ser_suggestion.vue?vue&type=style&index=0&id=46ab40a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ab40a8",
  null
  
)

export default component.exports